















































// @ts-nocheck
import { Component, Vue, Watch } from 'vue-property-decorator'
import { DataStore, SortDirection, Hub } from 'aws-amplify'

import {
  IChecklist,
} from '@/graphql/checklist/interfaces/checklist'

import AddDialog from '@/components/dialogs/Add.vue'
import ConfirmDialog from '@/components/dialogs/Confirm.vue'
import Draggable from 'vuedraggable'
import { GenerateLocaleDict } from '@/lib/Locale'
import { Checklist, District } from '../models/index'
import { mutateSnackbar } from '@/store/snackbar'
import { query as tenant } from '@/store/tenant'
import { HubEvents } from '@/amplify'

@Component<DistrictChecklistsView>({
  components: {
    Draggable,
    AddDialog,
    ConfirmDialog
  },
  // @ts-ignore
  metaInfo() {
    return {
      title: this.$t('checklists.title')
    }
  },
  apollo: {
    tenant,
  },
})
export default class DistrictChecklistsView extends Vue {
  checklists = []
  checklistsSubscription = null
  isSaving: boolean = false
  isLoading = true

  @Watch('tenant')
  async recreate() {
    this.subscribeToChecklists();
  }

  subscribeToChecklists() {
    if (!this.tenant) return;
    this.checklistsSubscription !== null && this.checklistsSubscription.unsubscribe();
    this.checklistsSubscription = DataStore.observeQuery(
      Checklist,
      p => p.and(p => [
        p.tenant.eq(this.tenant.id),
        p.districtID.eq(this.districtId),
      ]),
      {
        sort: s => s.sortPosition(SortDirection.ASCENDING)
      }
    ).subscribe(({ items }) => {
      this.checklists = Array.from(items)
      setTimeout(() => {
        this.isLoading = false
      }, 250)
    })
  }

  created() {
    this.subscribeToChecklists()
  }
  destroyed() {
    this.checklistsSubscription.unsubscribe()
  }
  @Watch('districtId')
  refetchPage() {
    this.subscribeToChecklists()
  }

  get districtId() {
    return this.$route.params.districtId
  }

  dispatchUpdateEventToHub(event) {
    Hub.dispatch('ListEdit', {
      event,
      data: {
        model: 'Checklist',
      }
    })
  }

  async addChecklist(title: string) {
    try {
      await DataStore.save(
        new Checklist({
          title: GenerateLocaleDict({ de: title }),
          sortPosition: this.checklists.length,
          color: `#2e2e2e`,
          tenant: this.tenant?.id,
          districtChecklistsId: this.districtId,
          districtID: this.districtId,
        })
      )
      mutateSnackbar(
        { text: String(`Checkliste erstellt.`), color: `success` },
        this.$apollo
      )
      this.dispatchUpdateEventToHub(HubEvents.itemAdd)
      this.subscribeToChecklists()
    } catch (err) {
      mutateSnackbar({ text: err, color: `error` }, this.$apollo)
    }
  }

  async deleteChecklist(checklist: IChecklist) {
    try {
      await DataStore.delete(Checklist, item => item.id.eq(checklist.id))
      mutateSnackbar(
        { text: String(`Checkliste gelöscht.`), color: `success` },
        this.$apollo
      )
      this.dispatchUpdateEventToHub(HubEvents.itemDelete)
    } catch (err) {
      mutateSnackbar(
        { text: JSON.stringify(err.message), color: `error` },
        this.$apollo
      )
    }
  }

  async saveOrder() {
    if (!this.checklists || this.checklists.length <= 0) return
    try {
      this.isSaving = true
      this.checklistsSubscription.unsubscribe()
      for (const [index, checklist] of this.checklists.entries()) {
        await DataStore.save(
          Checklist.copyOf(checklist, updated => {
            updated.sortPosition = index
          })
        )
      }
    } catch(err) {
      mutateSnackbar(
        { text: JSON.stringify(err.message), color: `error` },
        this.$apollo
      )
    }
    this.subscribeToChecklists()
    this.dispatchUpdateEventToHub(HubEvents.orderSave)
    setTimeout(() => {
      this.isSaving = false
    }, 250)
  }
}
